<template>
  <CHeader class="p-0 p-lg-3 the-header flex-column-reverse flex-xl-row">
    <div v-if="userRole === 'student'" class="text-end">
      <HelpCenterButton
        classes="top-right mt-1 me-2"
        width="17"
        height="17"
        content-key="student_header"
      />
    </div>
    <CHeaderNav class="mx-auto c-breadcrumb-container">
      <CNavItem />
    </CHeaderNav>

    <CHeaderNav class="py-2 px-2 px-lg-0 py-md-0">
      <HeaderToggler
        data-test-id="sidebar-toggler"
        classes="me-auto d-lg-none c-header-toggler"
        @click="$store.commit('layout/toggleSidebarMobile')"
      />

      <CNavItem class="pe-1 pe-sm-3 c-d-legacy-none">
        <TheHeaderCreateButton
          v-if="userRole !== 'student'"
          :user-role="userRole"
        />
      </CNavItem>

      <CNavItem
        v-if="userRole !== 'student'"
        class="me-2 me-sm-3 d-flex align-items-center"
      >
        <HelpCenterButton
          data-test-id="header-helpcenter-btn"
          content-key="header asist"
          :custom="`<i class=&quot;flaticon-question-2&quot;></i>`"
        />
      </CNavItem>
      <TheHeaderDigitalID
        class="me-2 me-sm-3"
        v-if="userRole === 'student'"
      ></TheHeaderDigitalID>
      <TheHeaderDropdownNotif
        data-test-id="header-notification-btn"
        v-if="userRole === 'student'"
      />

      <CNavItem class="me-2 me-sm-3 c-d-legacy-none">
        <TheHeaderSoundBtn data-test-id="header-sound-btn" :user="user" />
      </CNavItem>
      <TheHeaderDropdownAccnt data-test-id="header-user-box" :user="user" />
      <TheHeaderDropdownSchool />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt"
import TheHeaderDropdownNotif from "./TheHeaderDropdownNotif"
import TheHeaderDropdownSchool from "./TheHeaderDropdownSchool"
import TheHeaderCreateButton from "./TheHeaderCreateButton"
import HelpCenterButton from "@/components/HelpCenterButton"
import TheHeaderSoundBtn from "./TheHeaderSoundBtn"
import TheHeaderDigitalID from "./TheHeaderDigitalID.vue"
import HeaderToggler from "./HeaderToggler.vue"
import { mapGetters } from "vuex"

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownSchool,
    TheHeaderCreateButton,
    HelpCenterButton,
    TheHeaderSoundBtn,
    TheHeaderDigitalID,
    HeaderToggler
  },
  computed: {
    ...mapGetters({
      user: "authentication/user",
      userRole: "authentication/getUserRole"
    })
  },
  mounted() {
    if (this.userRole !== "student") {
      this.$store.dispatch("authentication/getUserSettings")
    }
  }
}
</script>
